"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.number.constructor");
var _couponCode = _interopRequireDefault(require("@/api/activity/couponCode.js"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'expandList',
  components: {},
  props: {
    actId: {
      type: Number,
      default: ''
    }
  },
  watch: {
    actId: {
      immediate: true,
      handler: function handler(newVal) {
        console.log('actId', newVal);
        // 有actId时选中，无actId时不选
        this.searchForm.activityId = newVal && newVal != 'null' ? newVal : '';
        this.searchForm.page = 1;
        this.fetchList(newVal);
      }
    }
  },
  data: function data() {
    return {
      shoplist: [],
      loading: false,
      searchForm: {
        status: '',
        exchangeCode: '',
        storeId: '',
        verifyStatus: '',
        page: 1,
        limit: 10,
        total: 0,
        mobile: '',
        cardNo: ''
      },
      tableData: [],
      downloadLoading: false
    };
  },
  computed: {
    maxHeight: function maxHeight() {
      return "".concat(window.innerHeight - 497, "px");
    }
  },
  methods: {
    download: function download() {
      var _this = this;
      this.downloadLoading = true;
      var params = {
        activityId: this.searchForm.activityId,
        storeId: this.searchForm.storeId,
        exchangeCode: this.searchForm.exchangeCode,
        status: this.searchForm.status,
        verifyStatus: this.searchForm.verifyStatus,
        mobile: this.searchForm.mobile,
        cardNo: this.searchForm.cardNo
      };
      _couponCode.default.exportCouponData(params).then(function (response) {
        var blob = new Blob([response], {
          type: 'application/vnd.ms-excel'
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = '优惠券列表.xlsx';
        link.click();
        window.URL.revokeObjectURL(link.href);
      }).finally(function () {
        _this.downloadLoading = false;
      });
    },
    changeTime: function changeTime(e) {
      console.log(e);
    },
    indexMethod: function indexMethod(index) {
      return (this.searchForm.page - 1) * this.searchForm.limit + index + 1;
    },
    handleTabChange: function handleTabChange(tab) {
      this.activeTab = tab.name;
    },
    fetchList: function fetchList() {
      var _this2 = this;
      this.loading = true;
      console.log(this.searchForm);
      _couponCode.default.getCouponList(this.searchForm).then(function (res) {
        _this2.tableData = res.records || [];
        _this2.searchForm.total = res.total || 0;
      }).finally(function () {
        _this2.loading = false;
      });
    },
    // 每页条数变化
    handleSizeChange: function handleSizeChange(newSize) {
      this.searchForm.limit = newSize;
      this.searchForm.page = 1;
      this.fetchList();
    },
    // 页码变化
    handlePageChange: function handlePageChange(newPage) {
      this.searchForm.page = newPage;
      this.fetchList();
    },
    getShopList: function getShopList() {
      var _this3 = this;
      _couponCode.default.getStoreList().then(function (res) {
        _this3.shoplist = res;
      });
    }
  },
  mounted: function mounted() {
    this.getShopList();
    this.fetchList();
  }
};